var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYuanhuanti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_1758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53587 6.63679L1.07172 4.35944V12.2179L1.84153 13.8217L4.72832 15.0406L8.35285 15.65L12.1378 15.0406L14.7359 12.7632V4.35944L11.6887 6.63679L8.1604 7.05378L4.53587 6.63679Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3749 2.20072L1.53913 3.36573C1.46548 3.4684 1.43343 3.59516 1.44943 3.7205L1.58499 4.78244C1.60511 4.94001 1.6989 5.07865 1.83768 5.15594L4.072 6.40038C4.12421 6.42945 4.1812 6.44894 4.24029 6.4579L8.70843 7.13583C8.77019 7.1452 8.83316 7.14291 8.89407 7.12909L12.4932 6.31248C12.5756 6.29378 12.652 6.25448 12.7151 6.19826L14.4275 4.67316C14.5758 4.54104 14.6319 4.33363 14.5703 4.14477L14.248 3.15626C14.2109 3.04265 14.1344 2.94607 14.0323 2.88401L11.0385 1.06426C10.9603 1.01668 10.8704 0.991516 10.7788 0.991516H6.90508C6.86536 0.991516 6.82578 0.996249 6.78718 1.00562L2.66327 2.00627C2.54698 2.03449 2.44466 2.10348 2.3749 2.20072Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7679 12.0294C14.7679 13.8818 11.7378 15.3834 8.00001 15.3834C4.26219 15.3834 1.23209 13.8818 1.23209 12.0294",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23206 12.3683C1.23206 10.516 4.26217 9.01433 7.99999 9.01433C11.7378 9.01433 14.7679 10.516 14.7679 12.3683",
    stroke: "black",
    strokeDasharray: "1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7491 3.75496C14.7491 4.45323 14.1642 5.22261 12.9038 5.8472C11.6747 6.45634 9.9416 6.84741 8 6.84741C6.05841 6.84741 4.32532 6.45634 3.09617 5.8472C1.83583 5.22261 1.25095 4.45323 1.25095 3.75496C1.25095 3.05668 1.83583 2.28731 3.09617 1.66271C4.32532 1.05358 6.05841 0.662506 8 0.662506C9.9416 0.662506 11.6747 1.05358 12.9038 1.66271C14.1642 2.28731 14.7491 3.05668 14.7491 3.75496Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4169 3.75498C11.4169 3.83056 11.3844 3.94078 11.2478 4.08358C11.1088 4.2289 10.8839 4.38256 10.5675 4.52246C9.93605 4.80168 9.02872 4.98706 8 4.98706C6.97128 4.98706 6.06395 4.80168 5.43252 4.52246C5.11615 4.38256 4.89121 4.2289 4.75221 4.08358C4.61562 3.94078 4.58307 3.83056 4.58307 3.75498C4.58307 3.67939 4.61562 3.56918 4.75221 3.42637C4.89121 3.28105 5.11615 3.12739 5.43252 2.98749C6.06395 2.70827 6.97128 2.52289 8 2.52289C9.02872 2.52289 9.93605 2.70827 10.5675 2.98749C10.8839 3.12739 11.1088 3.28105 11.2478 3.42637C11.3844 3.56918 11.4169 3.67939 11.4169 3.75498Z",
    fill: "#95E3FB",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23209 3.88428V12.1588",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7679 3.75494V12.0294",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_1758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuanhuanti);
export default __webpack_public_path__ + "static/media/yuanhuanti.d14f71badaa9b9dc879fc27ede3962ec.svg";
export { ForwardRef as ReactComponent };